"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

exports.default = function (config, appName) {
    if (typeof config === "function") {
        config = {
            appName: appName,
            router: {
                routes: [{
                    page: config
                }]
            }
        };
    }

    (0, _validateConfig2.default)(config);

    if (config.appName && typeof config.appName === "string") {
        if (!document.getElementById(config.appName)) {
            throw new Error("\u627E\u4E0D\u5230id=\"" + config.appName + "\"\u7684DOM\u8282\u70B9\uFF0C\u8BF7\u68C0\u67E5createApp\u7684\u53C2\u6570appName\uFF0C\u8BE6\u60C5\u89C1\uFF1Ahttps://bone.aliyun.com/bone-web/bonewebsdk.html?name=umpsu2#options");
        }
    }
    config.container = config.appName;
    delete config.appName;

    // 第二个app实例开始，如果没有指定historyMode，使用memory方式
    // 主要用于插件中
    if (global._boneWebAppLenth && !config.historyMode) {
        config.historyMode = "memory";
    }
    // 兼容bone-web-sdk@0.3.x的插件，记录app实例数量
    // 除第一个app实例之外，全部用memory的history
    global._boneWebAppLenth = (global._boneWebAppLenth || 0) + 1;

    var hasNoMatch = false;

    if (config.component && !config.router) {
        config.router = {
            routes: [{
                page: config.component
            }]
        };

        delete config.component;
    }

    config.routes = config.router.routes.map(function (route) {
        route.layout = route.layout || config.layout;
        route.placeholder = route.placeholder || config.placeholder;

        if (!route.path || route.path === "*") {
            hasNoMatch = true;
        }

        return {
            path: route.path,
            component: route.page,
            layout: route.layout,
            placeholder: route.placeholder,
            initialProps: route.initialProps
        };
    });

    // 设置404页面
    if (!hasNoMatch) {
        config.routes.push({
            path: "*",
            component: config.router.notFound || _NoMatch2.default
        });
    }
    // 路由缓存
    config.routerCache = config.router.cache !== false;

    delete config.router;

    if (config.plugins) {
        if (!config.extensions) {
            config.extensions = config.plugins;
            console.warn("plugins\u5DF2\u7ECF\u6539\u540D\u4E3Aextensions");
        }

        delete config.plugins;
    }

    var app = new _Application2.default(config);

    if (config.autoListen !== false) {
        _webPlugin2.default.listen(function (_ref) {
            var _ref$path = _ref.path,
                path = _ref$path === undefined ? "" : _ref$path,
                _ref$params = _ref.params,
                params = _ref$params === undefined ? {} : _ref$params;

            var querystring = (0, _keys2.default)(params).map(function (name) {
                return [name, params[name]].join("=");
            }).join("&");
            if (querystring) {
                if (path.indexOf("?") === -1) {
                    querystring = "?" + querystring;
                } else {
                    querystring = "&" + querystring;
                }
            }
            app.navigation.replace(path + querystring);
        });
    }

    if (config.autoStart) {
        app.start();
    }

    // 将当前应用实例注册到加载器中
    if (_loader2.default && _loader2.default.register) {
        _loader2.default.register(app);
    }

    // 临时这么写
    // 等portal上线start后删除
    setTimeout(function () {
        app.start();
    }, 100);

    return app;
};

var _Application = require("./Application");

var _Application2 = _interopRequireDefault(_Application);

var _NoMatch = require("./NoMatch");

var _NoMatch2 = _interopRequireDefault(_NoMatch);

var _loader = require("@bone/loader");

var _loader2 = _interopRequireDefault(_loader);

var _webPlugin = require("@bone/web-plugin");

var _webPlugin2 = _interopRequireDefault(_webPlugin);

var _validateConfig = require("./validateConfig");

var _validateConfig2 = _interopRequireDefault(_validateConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./packages/bone-web@0.2/node_modules/_@bone_web@0.2.0-alpha.7@@bone/web/lib/createApp.js
// module id = 2437
// module chunks = 4